import { defaultTokens } from "./defaultTokens";
export function subscribeToWindowSizeClass(subscriber) {
    const mql = window.matchMedia("(max-width: 1024px)");
    subscriber({ sizeClass: mql.matches ? "small" : "regular" });
    const listener = (e) => {
        subscriber({ sizeClass: e.matches ? "small" : "regular" });
    };
    mql.addEventListener("change", listener);
    return {
        removeSubscriber: () => {
            mql.removeEventListener("change", listener);
        },
    };
}
export function setBaseFontSizeSubscriber() {
    return subscribeToWindowSizeClass(({ sizeClass }) => {
        const html = document.querySelector("html");
        if (html) {
            html.style.fontSize = sizeClass === "regular" ? "21px" : "16px";
        }
    });
}
export function getAssetUrl(assetFolder, url) {
    try {
        return new URL(url).href;
    }
    catch {
        return assetFolder.replace(/\/$/, "") + "/" + url.replace(/^\//, "");
    }
}
export function getFontFaceDefinition(assetFolder, fontVariant) {
    const sources = fontVariant.src
        .map(({ format, url }) => `url("${getAssetUrl(assetFolder, url)}") format("${format}")`)
        .join(", ");
    return `@font-face { font-family: "${fontVariant.value}"; src: ${sources}; font-weight: ${fontVariant.weight} }`;
}
export function getFontFaceDefinitions(assetFolder, fonts) {
    return Object.values(fonts)
        .map((fontStyle) => Object.values(fontStyle)
        .map((cur) => getFontFaceDefinition(assetFolder, cur))
        .join("\n"))
        .join("\n");
}
export function getDefaultFontFaceDefinitions() {
    return getFontFaceDefinitions("", defaultTokens.asset.font);
}
/**
 * Appends a style tag to the `head` of the document.
 * @param assetFolder
 * @param fonts
 * @returns A function to remove the style tag.
 */
export function setFontFaceDefinitions(assetFolder, fonts) {
    const styleTag = document.createElement("style");
    styleTag.textContent = getFontFaceDefinitions(assetFolder, fonts);
    document.head.appendChild(styleTag);
    return () => {
        document.head.removeChild(styleTag);
    };
}
/**
 * Appends a style tag to the `head` of the document.
 * @returns A function to remove the style tag.
 */
export function setDefaultFontFaceDefinitions() {
    const styleTag = document.createElement("style");
    styleTag.textContent = getDefaultFontFaceDefinitions();
    document.head.appendChild(styleTag);
    return () => {
        document.head.removeChild(styleTag);
    };
}
